// ** Logo
import logo from "@src/assets/images/logo/logo.svg";
import uncutGemLogo from "@src/views/new-design/shared/images/Brand_Oval_Info.png";
import styles from "@src/views/new-design/components/Footer/NewFooter.module.scss";
import { GLOBAL_CONFIG } from "../../../utility/global-config";

const SpinnerComponent = () => {
  return (
    <div
      className={`fallback-spinner app-loader ${
        GLOBAL_CONFIG.NEW_DESIGN ? "new-design-loading" : ""
      }`}
      style={{ background: "#283046" }}
    >
      {GLOBAL_CONFIG.NEW_DESIGN ? (
        <img
          src={uncutGemLogo}
          alt="Uncut Gems Logo"
          className={styles.logo}
          style={{
            border: "unset",
          }}
        />
      ) : (
        <img className="fallback-logo" src={logo} alt="logo" />
      )}
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  );
};

export default SpinnerComponent;
